module.exports = __webpack_public_path__ + "static/media/qrCodeBackground.70d7c645.png";